<ng-container *transloco="let t">
    <mat-card class="altair-card vulnerability-highlights-card mb-25 border-radius bg-white border-none d-block"
        [class.component-dark-theme]="themeService.isDark()" [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    {{t('vulnerability-highlights')}}
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="vulnerability-highlights-table">
                <div class="table-responsive"  #TABLE>
                    <table mat-table [dataSource]="dataSource">

                        <!-- Type Column -->
                        <ng-container matColumnDef="type">
                            <th style="width: 10%" mat-header-cell *matHeaderCellDef>
                                {{t('type')}}
                            </th>
                            <td mat-cell *matCellDef="let vulnerability">
                                <span class="badge text-soft-primary">{{vulnerability.type}}</span>
                            </td>
                        </ng-container>

                        <!-- Vulnerability Column -->
                        <ng-container matColumnDef="vulnerability">
                            <th style="width: 35%" mat-header-cell *matHeaderCellDef>
                                {{t('vulnerability')}}
                            </th>
                            <td mat-cell *matCellDef="let vulnerability">
                                {{vulnerability.name}}
                                <br>
                                <small class="text-muted">Discovered: {{vulnerability.discovered_date}}</small>
                            </td>
                        </ng-container>

                        <!-- Severity Column -->
                        <ng-container matColumnDef="severity">
                            <th style="width: 10%" mat-header-cell *matHeaderCellDef>
                                {{t('severity')}}
                            </th>
                            <td mat-cell *matCellDef="let vulnerability">
                                @if (vulnerability.severity == 'Info') {
                                <span class='badge text-soft-primary'>Info</span>
                                }
                                @else if (vulnerability.severity == 'Low') {
                                <span class='badge text-soft-warning'>Low</span>
                                }
                                @else if (vulnerability.severity == 'Medium') {
                                <span class='badge text-bg-warning'>Medium</span>
                                }
                                @else if (vulnerability.severity == 'High') {
                                <span class='badge text-soft-danger'>High</span>
                                }
                                @else if (vulnerability.severity == 'Critical') {
                                <span class='badge text-bg-danger'>Critical</span>
                                }
                                @else if (vulnerability.severity == 'Unknown') {
                                <span class='badge text-soft-info'>Unknown</span>
                                }
                            </td>
                        </ng-container>

                        <!-- numberVulnerabilities Column -->
                        <ng-container matColumnDef="vulnerableURL">
                            <th style="width: 45%" mat-header-cell *matHeaderCellDef>
                                {{t('vulnerableURL')}}
                            </th>
                            <td mat-cell *matCellDef="let vulnerability">
                                <a href="{{vulnerability.http_url}}" target="_blank" class="text-danger bs-tooltip" title="{{vulnerability.http_url}}">{{vulnerability.http_url|slice:0:50}}</a>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    </table>
                </div>
                <mat-paginator [pageSizeOptions]="pageSizes" showFirstLastButtons></mat-paginator>
                <button mat-raised-button color="altair" (click)="exportTOExcel()">{{t('export-as-excel')}}</button>
            </div>
        </mat-card-content>
    </mat-card>
</ng-container>
